import { render, staticRenderFns } from "./diseasePage.vue?vue&type=template&id=5f8394d0&scoped=true"
import script from "./diseasePage.vue?vue&type=script&lang=js"
export * from "./diseasePage.vue?vue&type=script&lang=js"
import style0 from "./diseasePage.vue?vue&type=style&index=0&id=5f8394d0&prod&scoped=true&lang=css"
import style1 from "./diseasePage.vue?vue&type=style&index=1&id=5f8394d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8394d0",
  null
  
)

export default component.exports